/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { RootStoreType } from "./index"


/**
 * WebhookDeliveryAttemptDtoBase
 * auto generated base class for the model WebhookDeliveryAttemptDtoModel.
 */
export const WebhookDeliveryAttemptDtoModelBase = ModelBase
  .named('WebhookDeliveryAttemptDto')
  .props({
    __typename: types.optional(types.literal("WebhookDeliveryAttemptDto"), "WebhookDeliveryAttemptDto"),
    id: types.identifier,
    /** ISO timestamp of the delivery attempt */
    time: types.union(types.undefined, types.string),
    /** Topic of the delivered event (e.g. route.published) */
    topic: types.union(types.undefined, types.null, types.string),
    /** Outcome of the attempt: 'success' or 'failed' */
    status: types.union(types.undefined, types.string),
    /** Delivery outcome code — an HTTP status like "401", or a named code for non-HTTP failures (e.g. timeouts) */
    code: types.union(types.undefined, types.null, types.string),
    /** Attempt number (1 for the first attempt, 2+ for retries) */
    attemptNumber: types.union(types.undefined, types.null, types.integer),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class WebhookDeliveryAttemptDtoModelSelector extends QueryBuilder {
  get id() { return this.__attr(`id`) }
  get time() { return this.__attr(`time`) }
  get topic() { return this.__attr(`topic`) }
  get status() { return this.__attr(`status`) }
  get code() { return this.__attr(`code`) }
  get attemptNumber() { return this.__attr(`attemptNumber`) }
}
export function selectFromWebhookDeliveryAttemptDto() {
  return new WebhookDeliveryAttemptDtoModelSelector()
}

export const webhookDeliveryAttemptDtoModelPrimitives = selectFromWebhookDeliveryAttemptDto().time.topic.status.code.attemptNumber
